import React from 'react';
import type { GalleryImage } from '../../hooks/useGallery';
import SkewedCard from '../common/SkewedCard';

interface GalleryItemProps {
  image: GalleryImage;
  onClick?: () => void;
}

const GalleryItem: React.FC<GalleryItemProps> = ({ image, onClick }) => {
  return (
    <SkewedCard
      className="overflow-hidden hover:shadow-lg transition-shadow duration-300"
      onClick={onClick}
      padding="p-0"
      borderColor="black"
      borderWidth={1}
    >
      <div className="relative pb-[66.666%] overflow-hidden">
        <img
          src={image.imageUrl}
          alt={image.title}
          className="absolute inset-0 w-full h-full object-cover cursor-pointer"
        />
      </div>
      <div className="p-4 bg-white">
        <h3 className="text-lg font-bold text-black truncate">
          {image.title}
        </h3>
        {image.description && (
          <p className="text-gray-600 text-sm line-clamp-2 mt-1">
            {image.description}
          </p>
        )}
      </div>
    </SkewedCard>
  );
};

export default GalleryItem;